
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Eye, EyeOff, Clock } from "lucide-react";

interface QuoteStatusIndicatorProps {
  viewed: boolean;
  viewCount: number;
  viewedAt?: string;
  paymentLinkViewed?: boolean;
  paymentLinkViewedAt?: string;
}

const QuoteStatusIndicator: React.FC<QuoteStatusIndicatorProps> = ({
  viewed,
  viewCount,
  viewedAt,
  paymentLinkViewed,
  paymentLinkViewedAt
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      <Badge variant={viewed ? "default" : "secondary"} className="text-xs">
        {viewed ? <Eye className="w-3 h-3 mr-1" /> : <EyeOff className="w-3 h-3 mr-1" />}
        {viewed ? `Viewed ${viewCount} time${viewCount !== 1 ? 's' : ''}` : 'Not viewed'}
      </Badge>
      
      {viewed && viewedAt && (
        <Badge variant="outline" className="text-xs">
          <Clock className="w-3 h-3 mr-1" />
          {new Date(viewedAt).toLocaleDateString()}
        </Badge>
      )}
      
      {paymentLinkViewed && paymentLinkViewedAt && (
        <Badge variant="default" className="text-xs bg-green-600">
          Payment link viewed
        </Badge>
      )}
    </div>
  );
};

export default QuoteStatusIndicator;
